import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Food } from '@app/_models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FoodService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<any>(`${environment.apiUrl}/FOOD/Get`);
    }

    getAllclassifications() {
        return this.http.get<any>(`${environment.apiUrl}/FoodClassification/GetWithSubClassification`);
    }

    getCategoriaID(id) {
        return this.http.get<any>(`${environment.apiUrl}/FOOD/GetByCategoryId?CategoryId=`+id);
    }

    getProductosCategoriaIDPage(id,page){
        console.log("request",`${environment.apiUrl}/FOOD/PaginateBySubCategoryId?SubCategoryId=`+id+`&page=`+page)
        return this.http.get<any>(`${environment.apiUrl}/FOOD/PaginateBySubCategoryId?SubCategoryId=`+id+`&page=`+page);
    }

    getID(id) {
        return this.http.get<any>(`${environment.apiUrl}/FOOD/GetByIdWithSubCategory?Id=`+id);
    }

    /*
    post(food: Food) {
        return this.http.post<Food>(`${environment.apiUrl}/FOOD/InsertOrUpdate`, food);
    }*/

}
